import React, { useState } from "react";
import PropertiesSlider from "shared/components-pages/proyectos/PropertiesSlider";
import { CPagesPath } from "shared/models/const/pages-path";
import SliderCollectionProperty from "@components/slider-collection-property";
import Link from "next/link";
import Button from "@components/Button";
import Styled from "@emotion/styled";
import SliderAgentsCardLarge from "@components/slider-agents-card-large";
import { useTranslations } from "next-intl";

function SliderSection(props: any) {
  const { profileInfo, IsUserCollection } = props;

  const [haveAgents, setHaveAgents] = useState<boolean>(true);

  const translationAgent = useTranslations("agencyProfile.agents");
  const translationProperties = useTranslations("agencyProfile.properties");
  const translationCollection = useTranslations("agencyProfile.collection");

  const collectionTitle = translationCollection("title") || "";

  const [title, ...rest] = collectionTitle.split(" ");

  return (
    <div>
      {haveAgents && (
        <WrapperContent>
          <Title>{translationAgent("title")}</Title>
          <SliderAgentsCardLarge
            setHaveAgents={setHaveAgents}
            filters={{
              agency: profileInfo?.id,
            }}
          ></SliderAgentsCardLarge>
          <ContainerBtn>
            <Link
              href={CPagesPath.es.agents_list + `?agency=${profileInfo.id}`}
              passHref
            >
              <Button component="a">{translationAgent("seeMore")}</Button>
            </Link>
          </ContainerBtn>
        </WrapperContent>
      )}

      <WrapperContent>
        <PropertiesSlider
          title={translationProperties("title")}
          subtitle=""
          filters={{}}
          refRequest="property-list-normal-query"
          detailPath={CPagesPath.es.property_detail}
        />
        <ContainerBtn>
          <Link href={CPagesPath.es.properties}>
            <Button component="a">{translationProperties("seeMore")}</Button>
          </Link>
        </ContainerBtn>
      </WrapperContent>

      <WrapperContent>
        <Title>
          {title} <TitleSpan>{rest.join(" ")}</TitleSpan>
        </Title>
        <SliderCollectionProperty />
        <ContainerBtn>
          <Link href={CPagesPath.es.collection_properties}>
            <Button component="a">{translationCollection("seeMore")}</Button>
          </Link>
        </ContainerBtn>
      </WrapperContent>
    </div>
  );
}

export default SliderSection;

const ContainerBtn = Styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 50px;
    margin-top: 30px;
`;

const WrapperContent = Styled.div`
    width: 90%;
    margin: auto;
    & .collection__card__description{
        color:var(--color-brand-blue-main);
        span{
        color:var(--color-brand-blue-main);
        }
      }
    @media screen and (max-width: 991px) {
      width: 100%;
    }
 `;

const Title = Styled.h2`
  width: 100%;
  text-align: center;
  text-transform: uppercase;
  font-size: 1.9rem;
  margin-bottom: 60px;
  margin-top: 80px;
  color: var(--color-brand-blue-main);
`;

const TitleSpan = Styled.span`
  font-weight: 300;
`;
